/**
 * Validated public env. Plain checks instead of a zod schema: this module is imported by _app, and zod
 * (~50 KB) would ship in the bundle every page downloads. Same contract: missing strings throw,
 * the enums fall back to their default and reject unknown values.
 */
const REQUIRED = [
  'NEXT_PUBLIC_GOOGLE_MANAGER_ID',
  'NEXT_PUBLIC_GOOGLE_ANALYTICS_ID',
  'NEXT_PUBLIC_GOOGLE_MANAGER_ID_ISHA',
  'NEXT_PUBLIC_GOOGLE_MANAGER_ID_MEDLEVE',
  'NEXT_PUBLIC_GOOGLE_ANALYTICS_ID_ISHA',
  'NEXT_PUBLIC_GOOGLE_ADS_ID_ISHA',
  'NEXT_PUBLIC_META_PIXEL_ID',
  'NEXT_PUBLIC_FACEBOOK_PIXEL',
  'NEXT_PUBLIC_USER_TOKEN',
  'NEXT_PUBLIC_IUGU_ACCOUNT_ID',
  'NEXT_PUBLIC_OPEN_JWT_SECRET',
  'NEXT_PUBLIC_GTM_CUSTOM_SRC',
  'NEXT_PUBLIC_GTM_CUSTOM_ID'
] as const

const APP_ENVS = ['local', 'staging', 'production'] as const
const NODE_ENVS = ['development', 'production', 'test', 'local'] as const

export type Env = Record<(typeof REQUIRED)[number], string> & {
  NEXT_PUBLIC_ENV: (typeof APP_ENVS)[number]
  NODE_ENV: (typeof NODE_ENVS)[number]
}

const oneOf = <T extends string>(name: string, value: string | undefined, allowed: readonly T[], fallback: T): T => {
  if (value === undefined) return fallback
  if (!(allowed as readonly string[]).includes(value)) throw new Error(`Invalid env ${name}: "${value}"`)
  return value as T
}

export const parseEnv = (raw: Record<string, string | undefined>): Env => {
  const missing = REQUIRED.filter((name) => typeof raw[name] !== 'string')
  if (missing.length) throw new Error(`Missing env: ${missing.join(', ')}`)
  return {
    ...(Object.fromEntries(REQUIRED.map((name) => [name, raw[name]])) as Record<(typeof REQUIRED)[number], string>),
    NEXT_PUBLIC_ENV: oneOf('NEXT_PUBLIC_ENV', raw.NEXT_PUBLIC_ENV, APP_ENVS, 'local'),
    NODE_ENV: oneOf('NODE_ENV', raw.NODE_ENV, NODE_ENVS, 'development')
  }
}
